'use client';

import { Button } from '@mui/material';
import { useContext } from 'react';

import { colors } from '@/colors';
import { AccordionContainer } from '@/components/AccordionContainer';
import { Container } from '@/components/Container';
import { Order } from '@/components/Order';
import { DataContext } from '@/contexts/DataContext';
import { OrderContext } from '@/contexts/OrderContext';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';

export const SectionDeclinedOrders = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  const { orderCountPerStatus } = useContext(DataContext);
  const { declinedOrdersTruncated } = useContext(OrderContext);

  const totalNrOfDeclinedOrders = orderCountPerStatus?.DECLINED ?? 0;
  const nrOfShownDeclinedOrders = declinedOrdersTruncated.length;
  const nrOfHiddenDeclinedOrders = totalNrOfDeclinedOrders - nrOfShownDeclinedOrders;

  return (
    <AccordionContainer
      keyName={'DECLINED_ORDERS'}
      visibleTitle={`${t('section.DECLINED_ORDERS')}: ${totalNrOfDeclinedOrders}`}
    >
      <Container sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {declinedOrdersTruncated.map((newOrder) => (
          <Order key={`declined-order-${newOrder.id}`} order={newOrder} />
        ))}
        {totalNrOfDeclinedOrders > 3 && (
          <Container debugColor={'forestgreen'} sx={{ color: colors.grayDarkest }}>
            {t('order.declined.xHiddenOrders', nrOfHiddenDeclinedOrders, undefined, { x: nrOfHiddenDeclinedOrders })}
          </Container>
        )}
        {totalNrOfDeclinedOrders === 0 && (
          <Container debugColor={'darkslateblue'} sx={{ marginTop: '12px' }}>
            ({t('order.declined.empty')})
          </Container>
        )}
        <Container debugColor={'darkslateblue'} sx={{ marginBottom: '12px' }}>
          <Button
            onClick={() => {
              push('/orders?status=DECLINED');
            }}
          >
            {nrOfHiddenDeclinedOrders > 0 ? t('general.showAll') : t('order.goToFocusedView')}
          </Button>
        </Container>
      </Container>
    </AccordionContainer>
  );
};
